import { api } from '@/lib/api/client'
import type { AdminMonitoringPanel } from '@/types/api'

export async function fetchAdminMonitoring(): Promise<AdminMonitoringPanel> {
  return api.get<AdminMonitoringPanel>('/api/admin/monitoring', { requireAuth: true })
}

export async function fetchAdminMonitoringSnapshot(options?: {
  fresh?: boolean
  signal?: AbortSignal
}): Promise<AdminMonitoringPanel> {
  const query = options?.fresh ? '?fresh=1' : ''
  return api.get<AdminMonitoringPanel>(`/api/admin/monitoring/snapshot${query}`, {
    requireAuth: true,
    signal: options?.signal,
  })
}
